/** Short submit-bar label when wireless check-in fails before hub save. */
export const CONFIGURATION_CHECKIN_FAILED_BUTTON_LABEL =
  "Check-in failed, reset with magnet";

export const CONFIGURATION_SUBMIT_FAILED_LABEL = "Submit failed";

export const CONFIGURATION_ALREADY_ON_ORDER_BUTTON_LABEL = "This device is already on this order.";

/** Operator-facing submit failure with a short bar label separate from alert detail. */
export class ConfigurationSubmitFailure extends Error {
  readonly submitButtonLabel: string;

  constructor(submitButtonLabel: string, detailMessage: string) {
    super(detailMessage);
    this.name = "ConfigurationSubmitFailure";
    this.submitButtonLabel = submitButtonLabel;
  }
}

export function configurationSubmitFailureButtonLabel(error: unknown): string {
  if (error instanceof ConfigurationSubmitFailure) {
    return error.submitButtonLabel;
  }
  if (error && typeof error === "object" && "body" in error) {
    const body = (error as { body?: unknown }).body;
    if (body && typeof body === "object" && "submitButtonLabel" in body) {
      const label = (body as { submitButtonLabel?: unknown }).submitButtonLabel;
      if (typeof label === "string" && label.trim() !== "") {
        return label.trim();
      }
    }
  }
  return "";
}
